type Props = {
  children: React.ReactNode
}

function InvestmentWrapper({ children }: Props) {
  return (
    <div className="p-3 px-5 pb-5 rounded-[20px] gap-15 border border-border-strong flex flex-col lg:p-10 lg:px-15 lg:pb-15">
      {children}
    </div>
  )
}

export { InvestmentWrapper }
